<div class="circle-credit-container">
  <!-- Header Section -->
  <div class="circle-credit-header">
    <div class="header-content">
      <div class="header-info">
        <h2 class="header-title">
          <i class="pi pi-chart-line"></i>
          Círculo de Crédito
        </h2>
        <p class="header-description">
          Gestión de información crediticia para 
          <span class="entity-badge" [class]="'entity-' + clientEntity.toLowerCase()">
            {{ clientEntity === 'Física' ? 'Persona Física' : 'Persona Moral' }}
          </span>
        </p>
      </div>
      <div class="header-actions">
        <p-button 
          icon="pi pi-pencil" 
          label="Editar Información"
          (onClick)="onEditCircleCredit()"
          [loading]="circleCreditService.loading"
          styleClass="p-button-primary">
        </p-button>
      </div>
    </div>
  </div>

  <!-- Content Section -->
  <div class="circle-credit-content">
    
    <!-- Loading State -->
    <div *ngIf="circleCreditService.loading" class="loading-container">
      <div class="loading-card">
        <p-progressSpinner></p-progressSpinner>
        <p>Cargando información de círculo de crédito...</p>
      </div>
    </div>

    <!-- Content Card -->
    <div *ngIf="!circleCreditService.loading" class="info-card">
      <div class="info-header">
        <h3>Detalles del Círculo de Crédito</h3>
        <p-button 
          *ngIf="getCircleCreditStatus() === 'Información disponible'"
          icon="pi pi-file-excel"
          label="Descargar Reporte"
          styleClass="p-button-success p-button-outlined"
          [loading]="isDownloading"
          [disabled]="isDownloading"
          (click)="downloadReport()">
        </p-button>
        <span 
          *ngIf="getCircleCreditStatus() !== 'Información disponible'"
          class="status-badge" 
          [class]="getCircleCreditStatusClass()">
          {{ getCircleCreditStatus() }}
        </span>
      </div>
      
      <div class="info-content">
        <!-- Vista detallada con tarjetas -->
        <div *ngIf="getCircleCreditStatus() === 'Información disponible'" class="credit-details">

          <!-- Layout para Persona Física - Estructura específica -->
          <div *ngIf="clientEntity === 'Física'" class="cards-grid pf-grid-structured">
            <!-- FILA 1: Información del Otorgante (ancho completo) -->
            <app-circle-credit-header-card 
              class="card-full-width"
              [data]="creditCircle" 
              [entityType]="clientEntity">
            </app-circle-credit-header-card>

            <!-- FILA 2: Datos Personales (ancho completo) -->
            <app-circle-credit-personal-data-card 
              class="card-full-width"
              [data]="creditCircle?.personalData">
            </app-circle-credit-personal-data-card>

            <!-- FILA 3: Información de Domicilio (ancho completo) -->
            <app-circle-credit-address-card 
              class="card-full-width"
              [data]="creditCircle?.address">
            </app-circle-credit-address-card>

            <!-- FILA 4: Información Laboral (ancho completo) -->
            <app-circle-credit-employment-card 
              class="card-full-width"
              [data]="creditCircle?.employment">
            </app-circle-credit-employment-card>

            <!-- FILA 5: Cifras de Control (ancho completo) -->
            <app-circle-credit-control-figures-card 
              class="card-full-width"
              [data]="creditCircle?.controlFigures">
            </app-circle-credit-control-figures-card>

            <!-- ÚLTIMA FILA: Detalle de Cuenta (ancho completo) -->
            <app-circle-credit-account-detail-card 
              class="card-bottom-full"
              [data]="creditCircle?.accountDetail">
            </app-circle-credit-account-detail-card>
          </div>

          <!-- Layout para Persona Moral - Estructura específica -->
          <div *ngIf="clientEntity === 'Moral'" class="cards-grid pm-grid-structured">
            <!-- Card principal de encabezado (información general) -->
            <app-circle-credit-header-card 
              class="card-full-width"
              [data]="creditCircle" 
              [entityType]="clientEntity">
            </app-circle-credit-header-card>

            <!-- FILA SUPERIOR: Información de la Empresa (ancho completo) -->
            <app-circle-credit-company-card 
              class="card-company-full"
              [data]="creditCircle?.company">
            </app-circle-credit-company-card>

            <!-- FILA INFERIOR: Accionista + Aval -->
            <app-circle-credit-shareholder-card 
              class="card-full-width"
              [data]="creditCircle?.shareholder">
            </app-circle-credit-shareholder-card>

            <app-circle-credit-guarantor-card 
              class="card-full-width"
              [data]="creditCircle?.guarantor">
            </app-circle-credit-guarantor-card>

            <!-- Card destacada de créditos -->
            <app-circle-credit-credits-card 
              class="card-full"
              [data]="creditCircle?.credits">
            </app-circle-credit-credits-card>
          </div>
        </div>

        <!-- Estados sin información -->
        <div class="info-description" *ngIf="getCircleCreditStatus() !== 'Información disponible'">
          <p *ngIf="getCircleCreditStatus() === 'Sin información'">
            La información del círculo de crédito se creará automáticamente al crear el arrendamiento.
            Una vez creada, podrá editarla haciendo clic en "Editar Información".
          </p>
          
          <p *ngIf="getCircleCreditStatus() === 'Información incompleta'">
            La información del círculo de crédito está parcialmente completada.
            Puede completarla haciendo clic en "Editar Información".
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Edición -->
  <app-circle-credit-edit-modal 
    *ngIf="circleCreditService.showEditModal"
    [visible]="circleCreditService.showEditModal"
    [entityType]="clientEntity"
    [formGroup]="circleCreditService.editForm"
    [loading]="circleCreditService.loading"
    (onHide)="circleCreditService.closeEditModal()"
    (onSave)="onSaveCircleCredit()">
  </app-circle-credit-edit-modal>
</div>

<p-toast></p-toast>
